import LegalPage from './LegalPage';

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-lg font-medium text-[#00163E] mb-3">{title}</h2>
      {children}
    </div>
  );
}

function P({ children }) {
  return <p className="mb-3">{children}</p>;
}

function List({ items }) {
  return (
    <ul className="list-disc list-inside space-y-1.5 mb-3 ml-2">
      {items.map((item, i) => <li key={i}>{item}</li>)}
    </ul>
  );
}

export default function PrivacidadPage() {
  return (
    <LegalPage title="Política de Privacidad" pageTitle="Conadvy | Privacidad">
      <p className="text-[#8A9BB1] text-xs mb-8">Última actualización: [FECHA]</p>

      <P>En Conadvy, la confidencialidad no es un requisito legal: es el núcleo de nuestro servicio. Esta Política de Privacidad explica, de forma transparente, qué datos personales tratamos, con qué finalidad, con qué base legal, con qué proveedores y qué derechos puede ejercer, de conformidad con el Reglamento (UE) 2016/679 (RGPD) y la Ley Orgánica 3/2018 (LOPDGDD).</P>

      <Section title="1. Responsable del tratamiento">
        <List items={[
          'Responsable: [RAZÓN SOCIAL, S.L.]',
          'NIF/CIF: [NIF/CIF]',
          'Domicilio: [DOMICILIO SOCIAL COMPLETO]',
          'Contacto para protección de datos: privacidad@conadvy.com',
        ]} />
      </Section>

      <Section title="2. Qué datos tratamos y cómo los obtenemos">
        <P>Todos los datos que tratamos nos los facilita usted directamente a través de los formularios del sitio web o en comunicaciones posteriores. No obtenemos datos de fuentes ajenas sin informarle, más allá de la verificación de información profesional pública (por ejemplo, su perfil de LinkedIn) cuando solicita participar como advisor.</P>

        <P><strong>a) Formulario de empresas / solicitud de diagnóstico:</strong> nombre y apellidos, cargo, correo electrónico corporativo, nombre de la empresa, web, sector, tramo de facturación, número de empleados, y la descripción del desafío o necesidad estratégica que usted decida facilitarnos.</P>

        <P><strong>b) Formulario de advisors / solicitud de acceso:</strong> nombre y apellidos, correo electrónico, trayectoria profesional, cargos desempeñados, sectores, años de experiencia, disponibilidad y demás información profesional que decida facilitarnos.</P>

        <P><strong>c) Contacto general:</strong> datos identificativos y de contacto, y el contenido de su mensaje.</P>

        <P>No solicitamos categorías especiales de datos (art. 9 RGPD). Le rogamos que no las incluya en campos de texto libre.</P>
      </Section>

      <Section title="3. Finalidades y bases legales">
        <div className="overflow-x-auto mb-4">
          <table className="w-full text-sm border-collapse">
            <thead>
              <tr className="border-b border-[#00163E]/10">
                <th className="text-left py-3 pr-4 font-medium text-[#00163E]">Finalidad</th>
                <th className="text-left py-3 font-medium text-[#00163E]">Base legal</th>
              </tr>
            </thead>
            <tbody className="text-[#00163E]/70">
              <tr className="border-b border-[#00163E]/5">
                <td className="py-3 pr-4">Gestionar su solicitud, evaluarla y contactarle para las siguientes fases del proceso</td>
                <td className="py-3">Medidas precontractuales (art. 6.1.b RGPD)</td>
              </tr>
              <tr className="border-b border-[#00163E]/5">
                <td className="py-3 pr-4">Proceso de selección y matching, incluidos perfiles anonimizados</td>
                <td className="py-3">Ejecución contractual (art. 6.1.b) e interés legítimo (art. 6.1.f)</td>
              </tr>
              <tr className="border-b border-[#00163E]/5">
                <td className="py-3 pr-4">Verificar trayectoria profesional de advisors</td>
                <td className="py-3">Interés legítimo (art. 6.1.f)</td>
              </tr>
              <tr className="border-b border-[#00163E]/5">
                <td className="py-3 pr-4">Comunicaciones sobre el estado de su solicitud</td>
                <td className="py-3">Ejecución contractual (art. 6.1.b)</td>
              </tr>
              <tr className="border-b border-[#00163E]/5">
                <td className="py-3 pr-4">Comunicaciones informativas sobre Conadvy</td>
                <td className="py-3">Consentimiento (art. 6.1.a), revocable</td>
              </tr>
              <tr>
                <td className="py-3 pr-4">Cumplir obligaciones legales (fiscales, mercantiles)</td>
                <td className="py-3">Obligación legal (art. 6.1.c)</td>
              </tr>
            </tbody>
          </table>
        </div>

        <P><strong>Decisiones automatizadas:</strong> el proceso de selección combina criterios estructurados con validación humana. Ninguna decisión con efectos significativos se adopta de forma exclusivamente automatizada.</P>

        <P><strong>Perfiles ciegos:</strong> si usted es advisor, su información profesional podrá presentarse a empresas de forma anonimizada. Su identidad solo se revela tras la firma del correspondiente acuerdo de confidencialidad.</P>
      </Section>

      <Section title="4. Destinatarios y encargados del tratamiento">
        <P>No vendemos ni cedemos sus datos a terceros con fines comerciales. Sus datos son tratados por los siguientes proveedores tecnológicos como encargados del tratamiento (art. 28 RGPD):</P>
        <List items={[
          'Emergent (Emergent AI, Inc.) — desarrollo y alojamiento del sitio web. Puede implicar transferencia a EE. UU.',
          'Make (Celonis, República Checa/UE) — automatización del flujo de formularios. Tratamiento en la UE.',
          'Notion (Notion Labs, Inc., EE. UU.) — gestión interna de solicitudes. Puede implicar transferencia a EE. UU.',
          'Microsoft 365 — correo electrónico y almacenamiento documental, datos en la UE.',
        ]} />
        <P>Los datos podrán comunicarse a administraciones públicas cuando exista obligación legal, y a asesores profesionales sujetos a deber de confidencialidad.</P>
      </Section>

      <Section title="5. Transferencias internacionales">
        <P>Algunos proveedores están establecidos en Estados Unidos. Las transferencias se amparan en el EU-U.S. Data Privacy Framework y, complementariamente, en las Cláusulas Contractuales Tipo aprobadas por la Comisión Europea, junto con medidas adicionales de seguridad. Puede solicitar más información en privacidad@conadvy.com.</P>
      </Section>

      <Section title="6. Plazos de conservación">
        <List items={[
          'Solicitudes no admitidas o no continuadas: hasta 12 meses desde la última interacción.',
          'Advisors admitidos y empresas cliente: durante la relación y, tras su fin, bloqueados durante los plazos de prescripción legales.',
          'Comunicaciones comerciales consentidas: hasta que revoque su consentimiento.',
        ]} />
      </Section>

      <Section title="7. Sus derechos">
        <P>Puede ejercer en cualquier momento sus derechos de <strong>acceso, rectificación, supresión, oposición, limitación del tratamiento y portabilidad</strong>, así como retirar los consentimientos otorgados, escribiendo a privacidad@conadvy.com.</P>
        <P>Si considera que el tratamiento no se ajusta a la normativa, puede presentar una reclamación ante la Agencia Española de Protección de Datos (www.aepd.es).</P>
      </Section>

      <Section title="8. Seguridad">
        <P>Aplicamos medidas técnicas y organizativas apropiadas al riesgo: cifrado de comunicaciones (TLS), control de accesos con autenticación reforzada, principio de mínimo acceso, copias de seguridad periódicas y compromisos de confidencialidad de todas las personas que intervienen en el proceso.</P>
      </Section>

      <Section title="9. Cookies">
        <P>Este sitio web utiliza únicamente las cookies técnicas imprescindibles para su funcionamiento. No utilizamos cookies de seguimiento, analítica ni publicidad. Si en el futuro se incorporan cookies adicionales, se solicitará su consentimiento previo mediante un panel de configuración.</P>
        <P>Consulte nuestra <a href="/cookies" className="text-[#C58C40] hover:underline">Política de Cookies</a> para más información.</P>
      </Section>

      <Section title="10. Actualizaciones">
        <P>Podremos actualizar esta Política para adaptarla a cambios normativos u operativos. La versión vigente estará siempre publicada en esta página con su fecha de actualización.</P>
      </Section>
    </LegalPage>
  );
}
